// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__272YU","content":"RecentSearches_content__2Dpmr"};